import { create } from 'zustand';

export interface Category {
  id: string;
  familyId: string;
  name: string;
  icon: string; // klucz do mapowania ikony (z FE → lucide via categoryIconMap)
  color: string; // hex
  type: 'income' | 'expense';
  isDefault: boolean;
  order: number;
}

interface CategoriesStore {
  categories: Category[];
  setCategories: (categories: Category[]) => void;
  reset: () => void;
}

export const useCategoriesStore = create<CategoriesStore>((set) => ({
  categories: [],
  setCategories: (categories) => set({ categories }),
  reset: () => set({ categories: [] }),
}));

// Helper: znajdź kategorię po ID
export const findCategory = (categories: Category[], id: string | null): Category | undefined =>
  id ? categories.find((c) => c.id === id) : undefined;
